import Vue from 'vue'
import Router from 'vue-router'
import login from '../pages/login/Login'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: login
    },
    {
      path: '/home',
      name: 'Home',
      redirect: '/home/user',
      component: () =>
        import ('../pages/home/Home.vue'),
      meta: {requiresAuth: true},
      children: [{
        path: 'personnel',
        name: 'Personnel',
        // meta: { requiresAuth: true },
        component: () =>
          import ('../pages/personnel/personnel.vue')
      },
        {
          path: 'shopHandle',
          name: 'ShopHandle',
          // meta: { requiresAuth: true },
          component: () =>
            import ('../pages/ShopHandle/ShopHandle.vue')
        },

        {
          path: 'goodslist',
          name: 'Goodslist',
          // meta: { requiresAuth: true },
          component: () =>
            import ('../pages/goodslist/goodslist.vue')
        },
        {
          path: 'cinema',
          name: 'Cinema',
          component: () =>
            import ('../pages/cinema/cinema.vue')
        },
        {
          path: 'personalOrderReal',
          name: 'PersonalOrderReal',
          component: () =>
            import ('../pages/personalOrderReal/PersonalOrderReal')
        },
        {
          path: 'personalOrderOnline',
          name: 'PersonalOrderOnline',
          component: () =>
            import ('../pages/personalOrderOnline/PersonalOrderOnline')
        },
        {
          path: 'groupOrderOnline',
          name: 'GroupOrderOnline',
          component: () =>
            import ('../pages/groupOrderOnline/GroupOrderOnline')
        },
        {
          path: 'groupOrderReal',
          name: 'GroupOrderReal',
          component: () =>
            import ('../pages/groupOrderReal/GroupOrderReal')
        },
        {
          path: 'indexPosters',
          name: 'IndexPosters',
          component: () =>
            import ('../pages/indexPosterImage/indexPosterImage.vue')
        },
        {
          path: 'posters',
          name: 'Posters',
          component: () =>
            import ('../pages/posters/posters.vue')
        },
        {
          path: 'tickets',
          name: 'Tickets',
          component: () =>
            import ('../pages/tickets/tickets.vue')
        },
        {
          path: 'verification',
          name: 'Verification',
          component: () =>
            import ('../pages/verification/verification.vue')
        },
        {
          path: 'user',
          name: 'User',
          component: () =>
            import ('../pages/user/user.vue')
        },
        {
          path: 'banner',
          name: 'Banner',
          component: () =>
            import ('../pages/banner/banner.vue')
        },
        {
          path: 'shop',
          name: 'Shop',
          component: () =>
            import ('../pages/shop/shops.vue')
        },
        {
          path: 'sendMessage',
          name: 'sendMessage',
          component: () =>
            import ('../pages/sendMessage/sendMessage.vue')
        },
        {
          path: 'with',
          name: 'with',
          component: () =>
            import ('../pages/withCompany/withCompany.vue')
        },
        {
          path: 'viewCard',
          name: 'viewCard',
          component: () =>
            import ('../pages/viewCard/viewCard.vue')
        },
        {
          path: 'userViewCard',
          name: 'userViewCard',
          component: () =>
            import ('../pages/userViewCard/userViewCard.vue')
        },
        {
          path: 'quickBuyTicket',
          name: 'quickBuyTicket',
          component: () =>
            import ('../pages/quickBuyTicket/quickBuyTicket.vue')
        },
        {
          path: 'autoOrder',
          name: 'autoOrder',
          component: () =>
            import ('../pages/autoOrder/autoOrder.vue')
        },
        {
          path: 'viewCardGiveRecord',
          name: 'viewCardGiveRecord',
          component: () =>
            import ('../pages/viewCardGiveRecord/viewCardGiveRecord.vue')
        },
        {
          path: 'myOrder',
          name: 'myOrder',
          component: () =>
            import ('../pages/myOrder/myOrder.vue')
        },
        {
          path: 'stOrder',
          name: 'stOrder',
          component: () =>
            import ('../pages/stOrder/stOrder.vue')
        },
        {
          path: 'stCity',
          name: 'stCity',
          component: () =>
            import ('../pages/stCity/stCity.vue')
        },
        {
          path: 'myTiming',
          name: 'myTiming',
          component: () =>
            import ('../pages/myTiming/myTiming.vue')
        },
        {
          path: 'merchant',
          name: 'merchant',
          component: () =>
            import ('../pages/comMerchant/comMerchant.vue')
        },
        {
          path: 'publicity',
          name: 'publicity',
          component: () =>
            import ('../pages/comPublicity/comPublicity.vue')
        },
        {
          path: 'evaluate',
          name: 'evaluate',
          component: () =>
            import ('../pages/comEvaluate/comEvaluate.vue')
        },
        {
          path: 'merOrder',
          name: 'merOrder',
          component: () =>
            import ('../pages/comMerOrder/comMerOrder.vue')
        },
        {
          path: 'merTicket',
          name: 'merTicket',
          component: () =>
            import ('../pages/comMerTicket/comMerTicket.vue')
        },
        {
          path: 'fullReduction',
          name: 'fullReduction',
          component: () =>
            import ('../pages/fullReduction/fullReduction.vue')
        },
        {
          path: 'merLabel',
          name: 'merLabel',
          component: () =>
            import ('../pages/comMerLabel/comMerLabel.vue')
        },
        {
          path: 'couponCode',
          name: 'couponCode',
          component: () =>
            import ('../pages/couponCode/couponCode.vue')
        },
        {
          path: 'bank',
          name: 'bank',
          component: () =>
            import ('../pages/bankInfo/bankInfo.vue')
        },
        {
          path: 'bankHandle',
          name: 'bankHandle',
          component: () =>
            import ('../pages/bankHandle/bankHandle.vue')
        },
        {
          path: 'shopInfo',
          name: 'shopInfo',
          component: () =>
            import ('../pages/shopInfo/shopInfo.vue')
        },
        {
          path: 'shopEntityOrder',
          name: 'shopEntityOrder',
          component: () =>
            import ('../pages/shopEntityOrder/shopEntityOrder.vue')
        },
        {
          path: 'shopEOrder',
          name: 'shopEOrder',
          component: () =>
            import ('../pages/shopEOrder/shopEOrder.vue')
        },
        {
          path: 'shopTicket',
          name: 'shopTicket',
          component: () =>
            import ('../pages/shopTicket/shopTicket.vue')
        },
        {
          path: 'shopMerchant',
          name: 'shopMerchant',
          component: () =>
            import ('../pages/shopMerchant/shopMerchant.vue')
        },
        {
          path: 'shopMerHandle',
          name: 'shopMerHandle',
          component: () =>
            import ('../pages/shopMerHandle/shopMerHandle.vue')
        },
        {
          path: 'comboInfo',
          name: 'comboInfo',
          component: () =>
            import ('../pages/comboInfo/comboInfo.vue')
        },
        {
          path: 'comboOrder',
          name: 'comboOrder',
          component: () =>
            import ('../pages/comboOrder/comboOrder.vue')
        },
        {
          path: 'cardInfo',
          name: 'cardInfo',
          component: () =>
            import ('../pages/cardInfo/cardInfo.vue')
        },
        {
          path: 'userGiftCard',
          name: 'userGiftCard',
          component: () =>
            import ('../pages/userGiftCard/userGiftCard.vue')
        },
        {
          path: 'showMerchant',
          name: 'showMerchant',
          component: () =>
            import ('../pages/showMerchant/showMerchant.vue')
        },
        {
          path: 'showSite',
          name: 'showSite',
          component: () =>
            import ('../pages/showSite/showSite.vue')
        },
        {
          path: 'showProduct',
          name: 'showProduct',
          component: () =>
            import ('../pages/showProduct/showProduct.vue')
        },
        {
          path: 'giveActivity',
          name: 'giveActivity',
          component: () =>
            import ('../pages/giveActivity/giveActivity.vue')
        },
        {
          path: 'giveActivityRecord',
          name: 'giveActivityRecord',
          component: () =>
            import ('../pages/giveActivityRecord/giveActivityRecord.vue')
        },
        {
          path: 'showSession',
          name: 'showSession',
          component: () =>
            import ('../pages/showSession/showSession.vue')
        },
        {
          path: 'showOrder',
          name: 'showOrder',
          component: () =>
            import ('../pages/showOrder/showOrder.vue')
        },
        {
          path: 'showMerHandle',
          name: 'showMerHandle',
          component: () =>
            import ('../pages/showMerHandle/showMerHandle.vue')
        },
        {
          path: 'notAddGiveActivity',
          name: 'notAddGiveActivity',
          component: () =>
            import ('../pages/notAddGiveActivity/notAddGiveActivity.vue')
        },
        {
          path: 'adminLabel',
          name: 'adminLabel',
          component: () =>
            import ('../pages/adminLabel/adminLabel.vue')
        },
        {
          path: 'adminUserHandle',
          name: 'adminUserHandle',
          component: () =>
            import ('../pages/adminUserHandle/adminUserHandle.vue')
        },
        {
          path: 'adminLimit',
          name: 'adminLimit',
          component: () =>
            import ('../pages/adminLimit/adminLimit.vue')
        },
        {
          path: 'adminUserCreateTicket',
          name: 'adminUserCreateTicket',
          component: () =>
            import ('../pages/adminUserCreateTicket/adminUserCreateTicket.vue')
        },
        {
          path: 'qrcodeActivity',
          name: 'qrcodeActivity',
          component: () =>
            import ('../pages/qrcodeActivity/qrcodeActivity.vue')
        },
        {
          path: 'qrcodeActivityRecord',
          name: 'qrcodeActivityRecord',
          component: () =>
            import ('../pages/qrcodeActivityRecord/qrcodeActivityRecord.vue')
        },
        {
          path: 'miniIndexLabel',
          name: 'miniIndexLabel',
          component: () =>
            import ('../pages/miniIndexLabel/miniIndexLabel.vue')
        },
        {
          path: 'shopReserveQrcode',
          name: 'shopReserveQrcode',
          component: () =>
            import ('../pages/shopReserveQrcode/shopReserveQrcode.vue')
        },
        {
          path: 'commodityRange',
          name: 'commodityRange',
          component: () =>
            import ('../pages/commodityRange/commodityRange.vue')
        },
        {
          path: 'commodityType',
          name: 'commodityType',
          component: () =>
            import ('../pages/commodityType/commodityType.vue')
        },{
          path: 'mzOrder',
          name: 'mzOrder',
          component: () =>
            import ('../pages/mzOrder/mzOrder.vue')
        },{
          path: 'mzTiming',
          name: 'mzTiming',
          component: () =>
            import ('../pages/mzTiming/mzTiming.vue')
        },{
          path: 'newUserTask',
          name: 'newUserTask',
          component: () =>
            import ('../pages/newUserTask/newUserTask.vue')
        },{
          path: 'userNewUserTaskRecord',
          name: 'userNewUserTaskRecord',
          component: () =>
            import ('../pages/userNewUserTaskRecord/userNewUserTaskRecord.vue')
        },{
          path: 'wdExchange',
          name: 'wdExchange',
          component: () =>
            import ('../pages/wdExchange/wdExchange.vue')
        },{
          path: 'wdSignIn',
          name: 'wdSignIn',
          component: () =>
            import ('../pages/wdSignIn/wdSignIn.vue')
        },{
          path: 'wdTask',
          name: 'wdTask',
          component: () =>
            import ('../pages/wdTask/wdTask.vue')
        },{
          path: 'welfareActivit',
          name: 'welfareActivit',
          component: () =>
            import ('../pages/welfareActivit/welfareActivit.vue')
        },{
          path: 'ryOrder',
          name: 'ryOrder',
          component: () =>
            import ('../pages/ryOrder/ryOrder.vue')
        },{
          path: 'cyCostOrder',
          name: 'cyCostOrder',
          component: () =>
            import ('../pages/cyCostOrder/cyCostOrder.vue')
        },{
          path: 'userDistributionRecord',
          name: 'userDistributionRecord',
          component: () =>
            import ('../pages/userDistributionRecord/userDistributionRecord.vue')
        },{
          path: 'qpOrder',
          name: 'qpOrder',
          component: () =>
            import ('../pages/qpOrder/qpOrder.vue')
        },{
          path: 'qpTiming',
          name: 'qpTiming',
          component: () =>
            import ('../pages/qpTiming/qpTiming.vue')
        },{
          path: 'qpEntityOrder',
          name: 'qpEntityOrder',
          component: () =>
            import ('../pages/qpEntityOrder/qpEntityOrder.vue')
        },{
          path: 'qpShopTiming',
          name: 'qpShopTiming',
          component: () =>
            import ('../pages/qpShopTiming/qpShopTiming.vue')
        },{
          path: 'qpGoods',
          name: 'qpGoods',
          component: () =>
            import ('../pages/qpGoods/qpGoods.vue')
        },{
          path: 'qpGoodsOrder',
          name: 'qpGoodsOrder',
          component: () =>
            import ('../pages/qpGoodsOrder/qpGoodsOrder.vue')
        },{
          path: 'userPhoneGrantRecord',
          name: 'userPhoneGrantRecord',
          component: () =>
            import ('../pages/userPhoneGrantRecord/userPhoneGrantRecord.vue')
        },{
          path: 'userWdExchangeRecord',
          name: 'userWdExchangeRecord',
          component: () =>
            import ('../pages/userWdExchangeRecord/userWdExchangeRecord.vue')
        },{
          path: 'userWdSignInRecord',
          name: 'userWdSignInRecord',
          component: () =>
            import ('../pages/userWdSignInRecord/userWdSignInRecord.vue')
        },{
          path: 'userWdTaskRecord',
          name: 'userWdTaskRecord',
          component: () =>
            import ('../pages/userWdTaskRecord/userWdTaskRecord.vue')
        },{
          path: 'userGiftCardMergeRecord',
          name: 'userGiftCardMergeRecord',
          component: () =>
            import ('../pages/userGiftCardMergeRecord/userGiftCardMergeRecord.vue')
        },{
          path: 'sqActivity',
          name: 'sqActivity',
          component: () =>
            import ('../pages/sqActivity/sqActivity.vue')
        },{
          path: 'userSqActivityRecord',
          name: 'userSqActivityRecord',
          component: () =>
            import ('../pages/userSqActivityRecord/userSqActivityRecord.vue')
        },{
          path: 'pwtTiming',
          name: 'pwtTiming',
          component: () =>
            import ('../pages/pwtTiming/pwtTiming.vue')
        },{
          path: 'pwtPrjpaly',
          name: 'pwtPrjpaly',
          component: () =>
            import ('../pages/pwtPrjpaly/pwtPrjpaly.vue')
        },{
          path: 'pwtProduct',
          name: 'pwtProduct',
          component: () =>
            import ('../pages/pwtProduct/pwtProduct.vue')
        },{
          path: 'pwtProject',
          name: 'pwtProject',
          component: () =>
            import ('../pages/pwtProject/pwtProject.vue')
        },{
          path: 'ticketLimitInfo',
          name: 'ticketLimitInfo',
          component: () =>
            import ('../pages/ticketLimitInfo/ticketLimitInfo.vue')
        },{
          path: 'pwtVenue',
          name: 'pwtVenue',
          component: () =>
            import ('../pages/pwtVenue/pwtVenue.vue')
        },{
          path: 'pwtOrder',
          name: 'pwtOrder',
          component: () =>
            import ('../pages/pwtOrder/pwtOrder.vue')
        },{
          path: 'pwtDiscountMessage',
          name: 'pwtDiscountMessage',
          component: () =>
            import ('../pages/pwtDiscountMessage/pwtDiscountMessage.vue')
        },{
          path: 'userQpOrderCityRecord',
          name: 'userQpOrderCityRecord',
          component: () =>
            import ('../pages/userQpOrderCityRecord/userQpOrderCityRecord.vue')
        },{
          path: 'signItem',
          name: 'signItem',
          component: () =>
            import ('../pages/signItem/signItem.vue')
        },{
          path: 'userSignItem',
          name: 'userSignItem',
          component: () =>
            import ('../pages/userSignItem/userSignItem.vue')
        },{
          path: 'giveService',
          name: 'giveService',
          component: () =>
            import ('../pages/giveService/giveService.vue')
        },{
          path: 'userGiveServiceRecord',
          name: 'userGiveServiceRecord',
          component: () =>
            import ('../pages/userGiveServiceRecord/userGiveServiceRecord.vue')
        },{
          path: 'mzHandle',
          name: 'mzHandle',
          component: () =>
            import ('../pages/mzHandle/mzHandle.vue')
        },{
          path: 'pwtOrderTheater',
          name: 'pwtOrderTheater',
          component: () =>
            import ('../pages/pwtOrderTheater/pwtOrderTheater.vue')
        },{
          path: 'ypTiming',
          name: 'ypTiming',
          component: () =>
            import ('../pages/ypTiming/ypTiming.vue')
        },{
          path: 'ypOrder',
          name: 'ypOrder',
          component: () =>
            import ('../pages/ypOrder/ypOrder.vue')
        },{
          path: 'userViewCardLimitedCollar',
          name: 'userViewCardLimitedCollar',
          component: () =>
            import ('../pages/userViewCardLimitedCollar/userViewCardLimitedCollar.vue')
        },{
          path: 'ypCardOrder',
          name: 'ypCardOrder',
          component: () =>
            import ('../pages/ypCardOrder/ypCardOrder.vue')
        },{
          path: 'stShowTiming',
          name: 'stShowTiming',
          component: () =>
            import ('../pages/stShowTiming/stShowTiming.vue')
        },{
          path: 'userDataTiming',
          name: 'userDataTiming',
          component: () =>
            import ('../pages/userDataTiming/userDataTiming.vue')
        },{
          path: 'userDataRecord',
          name: 'userDataRecord',
          component: () =>
            import ('../pages/userDataRecord/userDataRecord.vue')
        },{
          path: 'luckdrawInfo',
          name: 'luckdrawInfo',
          component: () =>
            import ('../pages/luckdrawInfo/luckdrawInfo.vue')
        },{
          path: 'voteProduct',
          name: 'voteProduct',
          component: () =>
            import ('../pages/voteProduct/voteProduct.vue')
        },{
          path: 'userVoteCompeterecord',
          name: 'userVoteCompeterecord',
          component: () =>
            import ('../pages/userVoteCompeterecord/userVoteCompeterecord.vue')
        },{
          path: 'userLuckDrawRecord',
          name: 'userLuckDrawRecord',
          component: () =>
            import ('../pages/userLuckDrawRecord/userLuckDrawRecord.vue')
        },{
          path: 'userRenew',
          name: 'userRenew',
          component: () =>
            import ('../pages/userRenew/userRenew.vue')
        },{
          path: 'productAdjustment',
          name: 'productAdjustment',
          component: () =>
            import ('../pages/productAdjustment/productAdjustment.vue')
        },{
          path: 'viewCardAwardActivity',
          name: 'viewCardAwardActivity',
          component: () =>
            import ('../pages/viewCardAwardActivity/viewCardAwardActivity.vue')
        },{
          path: 'searchCompany',
          name: 'searchCompany',
          component: () =>
            import ('../pages/searchCompany/searchCompany.vue')
        },{
          path: 'searchDiscount',
          name: 'searchDiscount',
          component: () =>
            import ('../pages/searchDiscount/searchDiscount.vue')
        },{
          path: 'scmShopTiming',
          name: 'scmShopTiming',
          component: () =>
            import ('../pages/scmShopTiming/scmShopTiming.vue')
        },{
          path: 'scmShopInfo',
          name: 'scmShopInfo',
          component: () =>
            import ('../pages/scmShopInfo/scmShopInfo.vue')
        },{
          path: 'scmShopOrder',
          name: 'scmShopOrder',
          component: () =>
            import ('../pages/scmShopOrder/scmShopOrder.vue')
        },{
          path: 'shopBigType',
          name: 'shopBigType',
          component: () =>
            import ('../pages/shopBigType/shopBigType.vue')
        },{
          path: 'phTiming',
          name: 'phTiming',
          component: () =>
            import ('../pages/phTiming/phTiming.vue')
        },{
          path: 'phOrder',
          name: 'phOrder',
          component: () =>
            import ('../pages/phOrder/phOrder.vue')
        },{
          path: 'systemVal',
          name: 'systemVal',
          component: () =>
            import ('../pages/systemVal/systemVal.vue')
        },{
          path: 'pwtSystem',
          name: 'pwtSystem',
          component: () =>
            import ('../pages/pwtSystem/pwtSystem.vue')
        },{
          path: 'withHandle',
          name: 'withHandle',
          component: () =>
            import ('../pages/withHandle/withHandle.vue')
        },{
          path: 'generalTicketOrder',
          name: 'generalTicketOrder',
          component: () =>
            import ('../pages/generalTicketOrder/generalTicketOrder.vue')
        },{
          path: 'zyTiming',
          name: 'zyTiming',
          component: () =>
            import ('../pages/zyTiming/zyTiming.vue')
        },{
          path: 'wdVerifyNeedActivity',
          name: 'wdVerifyNeedActivity',
          component: () =>
            import ('../pages/wdVerifyNeedActivity/wdVerifyNeedActivity.vue')
        },{
          path: 'wdVerifyNeedDraw',
          name: 'wdVerifyNeedDraw',
          component: () =>
            import ('../pages/wdVerifyNeedDraw/wdVerifyNeedDraw.vue')
        },{
          path: 'pwtShowRecord',
          name: 'pwtShowRecord',
          component: () =>
            import ('../pages/pwtShowRecord/pwtShowRecord.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, form, next) => {
  if (to.name == 'Login') {
    next()
  } else {
    let token = window.localStorage.getItem('token')
    if (token) {
      next()
    } else {
      next('/')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js